import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit, Inject } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';

import { TranslateService } from '@services/translate.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule } from '@angular/forms';

export interface DialogData {
  data_ActivityCode: number;
  data_TicketId: string;
  data_Title: string;
}

@Component({
  selector: 'inbox-dialog',
  templateUrl: '../sharedTemplates/inbox.dialog.component.html',
})
export class InboxDialogComponent {
  title: string;
  data_ActivityCode: number;
  ticketDatas: UntypedFormGroup;
  ticketDataRaw: any;
  input_filepath = '';
  input_isdisabled = '';
  selectedCategory = 0;
  categoryList = [
    { id: 1, value: 'Mein Konto' },
    { id: 2, value: 'Technisches Problem' },
    { id: 3, value: 'Finanzen' },
    { id: 4, value: 'Wettschein-Fragen' },
    { id: 5, value: 'Cashback' },
    { id: 6, value: 'Sonstige' },
  ];

  constructor(
    public dialogRef: MatDialogRef<InboxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _DataHelper: DataHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    private _router: Router,
    private route: ActivatedRoute,
    private _FormBuilder: UntypedFormBuilder
  ) {
    this.ticketDatas = _FormBuilder.group({
      // Subject: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Message: new UntypedFormControl({ value: '', disabled: false }, []),
      FilePath: new UntypedFormControl({ value: '', disabled: false }),
      category: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      TicketId: this.data.data_TicketId,
      ActivityCode: this.data.data_ActivityCode,
    });
    this.title = data.data_Title;
    this.data_ActivityCode = data.data_ActivityCode;
  }

  ngOnInit() {
    this.ticketDatas.valueChanges.subscribe(x => {
      this.ticketDataRaw = x;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createCustomerTicket() {
    let Subject = '';
    if (this.data_ActivityCode == 2) {
      Subject = this.categoryList.filter(x => x.id == this.ticketDataRaw.category)[0].value;
    } else if (this.data_ActivityCode == 4) {
      Subject = this.title;
    }

    this.ticketDataRaw.FilePath = this.input_filepath;
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.AnswerTicketMessage(this.ticketDataRaw, this.ticketDataRaw.FilePath, Subject).then(result => {
      this._UiHelper.setLoadingDialog(false);
      if (result.code == 'error') {
        this._UiHelper.errorSnackBar(result.message, '');
      } else if (result.code == '104') {
        if (this.ticketDataRaw.TicketId == 0) {
          this.getCustomerTicket();
        } else {
          this.getCustomerTicketDetail(this.ticketDataRaw.TicketId);
        }
        this.dialogRef.close();
        this._UiHelper.successSnackBar(result.message, '');
      }
    });
  }

  getCustomerTicket() {
    this._ApiService.getCustomerTicket().then(CustomerTicketList => {
      this._DataHelper.DataCustomerTicketList = CustomerTicketList;
    });
  }

  getCustomerTicketDetail(ticketid) {
    this._ApiService.getCustomerTicketDetail(ticketid).then(CustomerTicketDetailList => {
      this._DataHelper.DataCustomerTicketDetailList = CustomerTicketDetailList;
    });
  }

  upload(files) {
    this._ApiService.UploadtoAWSFromSupport(files[0], 'support').then(result => {
      if (result.code == 'error') {
        this._UiHelper.errorSnackBar(result.message, '');
      } else if (result.code == 'success') {
        const t_message = this._TranslateService.instant('upload_successful');
        this._UiHelper.successSnackBar(t_message, '');
        this.input_filepath = result.message;
        this.input_isdisabled = 'disabled';
      }
    });
  }
}
